module.exports = __webpack_public_path__ + "img/l.8b1783ce.png";